<template lang="pug">
  #postalForm
    v-container(fluid)
      v-form
        v-layout.py-1(row wrap justify-space-between)
          v-flex(d-flex xs3)
            v-text-field(
              :v-model="folio"
              label="Folio"
              :value="folio"
              disabled
              append-icon="visibility"
            )
          v-flex(d-flex xs9 sm7)
            v-menu(
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              max-width="290px"
              )
              template(
                slot="activator"
              )
                v-text-field(
                  :value="dateFormattedMomentjs(aggressionDate)"
                  label="Fecha del hecho"
                  prepend-icon="event"
                  readonly
                )
              v-date-picker(v-model="aggressionDate" @input="menu1 = false" color="grey lighten-2")
            v-icon.visible(v-if="aggressionDateVisible" @click="visible('aggressionDate')") visibility
            v-icon.visible(v-if="!aggressionDateVisible" @click="visible('aggressionDate')") visibility_off
        v-layout.py-0.my-0(row wrap justify-end)
          v-flex.upload(d-flex sm6 xs12)
            p.bold.underline(@click="pickFile") Cargar fotografía
              span.ml-2
                font-awesome-icon(icon="upload" size="lg")
            input(
              type="file"
              style="display: none"
              ref="image"
              accept="image/*"
              @change="uploadPicture"
            )
          v-flex.upload.px-3(d-flex xs12 sm6)
            p.small.underline.dark-text.text-xs-right(@click="deleteFoto()") Eliminar fotografía
        v-layout.py-1.mt-3(row wrap align-end justify-space-between)
          v-flex.pr-2(d-flex xs6)
            v-autocomplete(
            :items="states"
            ref="Entidad"
            v-model="state"
            label="Entidad"
            placeholder="Selecciona la entidad"
            )
            v-icon.visible(v-if="stateVisible" @click="visible('state')") visibility
            v-icon.visible(v-if="!stateVisible" @click="visible('state')") visibility_off
          v-flex.pl-2(d-flex xs6)
            v-autocomplete(
            :items="municipalities"
            ref="Municipio"
            v-model="municipality"
            label="Municipio"
            placeholder="Selecciona el municipio"
            )
            v-icon.visible(v-if="municipalityVisible" @click="visible('municipality')") visibility
            v-icon.visible(v-if="!municipalityVisible" @click="visible('municipality')") visibility_off
        v-layout.py-1.px-0(row wrap align-center)
          v-text-field(
            v-model="legalName"
            ref="Nombre legal"
            label="Nombre legal"
          )
          v-icon.visible(v-if="legalNameVisible" @click="visible('legalName')") visibility
          v-icon.visible(v-if="!legalNameVisible" @click="visible('legalName')") visibility_off
        v-layout.py-1.px-0(row wrap align-center)
          v-text-field(
            v-model="chosenName"
            ref="Nombre elegido o asumido"
            label="Nombre elegido o asumido"
          )
          v-icon.visible(v-if="chosenNameVisible" @click="visible('chosenName')") visibility
          v-icon.visible(v-if="!chosenNameVisible" @click="visible('chosenName')") visibility_off
        v-layout.py-1.px-0(row wrap align-center)
          v-select(
            :items="options['whereWasFound']"
            v-model="whereWasFound"
            ref="Lugar donde apareció la víctima"
            label="Lugar donde apareció la víctima"
          )
          v-icon.visible(v-if="whereWasFoundVisible" @click="visible('whereWasFound')") visibility
          v-icon.visible(v-if="!whereWasFoundVisible" @click="visible('whereWasFound')") visibility_off
          v-flex.px-1(d-flex xs6 v-if="whereWasFound == 'Otro'")
            v-text-field(
              v-model="whereWasFoundOther"
              label="Especifica el lugar"
            )
        v-layout.py-1(row wrap align-end justify-space-between)
          v-flex.px-1(d-flex xs10 sm12)
            v-autocomplete(
              :items="options['sexualIdentity']"
              ref="Identidad de género/Orientación sexual"
              v-model="sexualIdentity"
              label="Identidad de género/Orientación sexual"
              placeholder="Selecciona"
            )
            v-icon.visible(v-if="sexualIdentityVisible" @click="visible('sexualIdentity')") visibility
            v-icon.visible(v-if="!sexualIdentityVisible" @click="visible('sexualIdentity')") visibility_off
          v-flex.px-1(d-flex xs10 sm12 v-if="sexualIdentity == 'Otro'")
            v-text-field(
              v-model="sexualIdentityOther"
              label="Especifica identidad u orentación"
            )
          v-flex.px-1(d-flex xs10 sm12)
            v-select(
              :items="options['characteristic']"
              v-model="characteristic"
              ref="Característica diferencial"
              label="Característica diferencial"
            )
            v-icon.visible(v-if="characteristicVisible" @click="visible('characteristic')") visibility
            v-icon.visible(v-if="!characteristicVisible" @click="visible('characteristic')") visibility_off
          v-flex.px-1(d-flex xs10 sm12 v-if="characteristic == 'Otro'")
            v-text-field(
              v-model="characteristicOther"
              label="¿Qué característica?"
            )
        v-layout.py-1(row wrap align-end justify-space-between)
          v-flex.px-1(d-flex xs12 sm6 md4)
            v-select(
              :items="ageOptions"
              v-model="age"
              ref="Edad"
              label="Edad"
            )
            v-icon.visible(v-if="ageVisible" @click="visible('age')") visibility
            v-icon.visible(v-if="!ageVisible" @click="visible('age')") visibility_off
          v-flex.px-1(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="nationality"
              ref="Nacionalidad"
              label="Nacionalidad"
            )
            v-icon.visible(v-if="nationalityVisible" @click="visible('nationality')") visibility
            v-icon.visible(v-if="!nationalityVisible" @click="visible('nationality')") visibility_off
          v-flex.px-1(d-flex xs12 sm6 md4)
            v-select(
              :items="options['occupation']"
              v-model="occupation"
              ref="Ocupación"
              label="Ocupación"
            )
            v-icon.visible(v-if="occupationVisible" @click="visible('occupation')") visibility
            v-icon.visible(v-if="!occupationVisible" @click="visible('occupation')") visibility_off
          v-flex.px-1(d-flex xs6 v-if="occupation == 'Otro'")
            v-text-field(
              v-model="occupationOther"
              label="Especifica ocupación"
            )
        v-layout.py-1.px-0(row wrap align-center)
          v-textarea(
            v-model="details"
            ref="Descripción de los hechos"
            label="Descripción de los hechos"
            required  
          )
          v-icon.visible(v-if="detailsVisible" @click="visible('details')") visibility
          v-icon.visible(v-if="!detailsVisible" @click="visible('details')") visibility_off
</template>

<script>
import $mx from "../services/mx.service.js";
import axios from "axios";
import moment from "moment";

export default {
  name: "PostalForm",
  props: {},
  data() {
    return {
      folio: this.$store.state.record.folio,
      states: $mx.getStates().sort(),
      menu1: false,
      ageOptions: ['S/D'].concat([...Array(100).keys()].slice(1))
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    options() {
      return this.$store.getters.options;
    },
    foto: {
      get() {
        return this.$store.state.record.foto;
      },
      set(value) {
        this.$store.commit("updateFoto", value);
      }
    },
    aggressionDateVisible: {
      get() {
        return this.$store.state.record.aggressionDateVisible;
      },
      set(value) {
        this.$store.commit("updateAggressionDateVisible", value);
      }
    },
    stateVisible: {
      get() {
        return this.$store.state.record.stateVisible;
      },
      set(value) {
        this.$store.commit("updateStateVisible", value);
      }
    },
    municipalityVisible: {
      get() {
        return this.$store.state.record.municipalityVisible;
      },
      set(value) {
        this.$store.commit("updateMunicipalityVisible", value);
      }
    },
    legalNameVisible: {
      get() {
        return this.$store.state.record.legalNameVisible;
      },
      set(value) {
        this.$store.commit("updateLegalNameVisible", value);
      }
    },
    chosenNameVisible: {
      get() {
        return this.$store.state.record.chosenNameVisible;
      },
      set(value) {
        this.$store.commit("updateChosenNameVisible", value);
      }
    },
    whereWasFoundVisible: {
      get() {
        return this.$store.state.record.whereWasFoundVisible;
      },
      set(value) {
        this.$store.commit("updateWhereWasFoundVisible", value);
      }
    },
    sexualIdentityVisible: {
      get() {
        return this.$store.state.record.sexualIdentityVisible;
      },
      set(value) {
        this.$store.commit("updateSexualIdentityVisible", value);
      }
    },
    characteristicVisible: {
      get() {
        return this.$store.state.record.characteristicVisible;
      },
      set(value) {
        this.$store.commit("updateCharacteristicVisible", value);
      }
    },
    ageVisible: {
      get() {
        return this.$store.state.record.ageVisible;
      },
      set(value) {
        this.$store.commit("updateAgeVisible", value);
      }
    },
    nationalityVisible: {
      get() {
        return this.$store.state.record.nationalityVisible;
      },
      set(value) {
        this.$store.commit("updateNationalityVisible", value);
      }
    },
    occupationVisible: {
      get() {
        return this.$store.state.record.occupationVisible;
      },
      set(value) {
        this.$store.commit("updateOccupationVisible", value);
      }
    },
    detailsVisible: {
      get() {
        return this.$store.state.record.detailsVisible;
      },
      set(value) {
        this.$store.commit("updateDetailsVisible", value);
      }
    },
    aggressionDate: {
      get() {
        return this.$store.state.record.aggressionDate;
      },
      set(value) {
        this.$store.commit("updateAggressionDate", value);
      }
    },
    municipality: {
      get() {
        return this.$store.state.record.municipality;
      },
      set(value) {
        this.$store.commit("updateMunicipality", value);
      }
    },
    state: {
      get() {
        return this.$store.state.record.state;
      },
      set(value) {
        this.$store.commit("updateState", value);
      }
    },
    legalName: {
      get() {
        return this.$store.state.record["legalName"];
      },
      set(value) {
        this.$store.commit("updateLegalName", value);
      }
    },
    chosenName: {
      get() {
        return this.$store.state.record["chosenName"];
      },
      set(value) {
        this.$store.commit("updateChosenName", value);
      }
    },
    whereWasFound: {
      get() {
        return this.$store.state.record["whereWasFound"];
      },
      set(value) {
        this.$store.commit("updateWhereWasFound", value);
      }
    },
    whereWasFoundOther: {
      get() {
        return this.$store.state.record["whereWasFoundOther"];
      },
      set(value) {
        this.$store.commit("updateWhereWasFoundOther", value);
      }
    },
    sexualIdentity: {
      get() {
        return this.$store.state.record["sexualIdentity"];
      },
      set(value) {
        this.$store.commit("updateSexualIdentity", value);
      }
    },
    sexualIdentityOther: {
      get() {
        return this.$store.state.record["sexualIdentityOther"];
      },
      set(value) {
        this.$store.commit("updateSexualIdentityOther", value);
      }
    },
    characteristic: {
      get() {
        return this.$store.state.record["characteristic"];
      },
      set(value) {
        this.$store.commit("updatecharacteristic", value);
      }
    },
    characteristicOther: {
      get() {
        return this.$store.state.record["characteristicOther"];
      },
      set(value) {
        this.$store.commit("updatecharacteristicOther", value);
      }
    },
    age: {
      get() {
        return this.$store.state.record["age"];
      },
      set(value) {
        this.$store.commit("updateAge", value);
      }
    },
    nationality: {
      get() {
        return this.$store.state.record["nationality"];
      },
      set(value) {
        this.$store.commit("updateNationality", value);
      }
    },
    occupation: {
      get() {
        return this.$store.state.record["occupation"];
      },
      set(value) {
        this.$store.commit("updateOccupation", value);
      }
    },
    occupationOther: {
      get() {
        return this.$store.state.record["occupationOther"];
      },
      set(value) {
        this.$store.commit("updateOccupationOther", value);
      }
    },
    details: {
      get() {
        return this.$store.state.record.details;
      },
      set(value) {
        this.$store.commit("updateDetails", value);
      }
    },
    municipalities() {
      if (!this.record.state) return [];
      else {
        return $mx.getMuns(this.record.state).sort();
      }
    }
  },
  methods: {
    dateFormattedMomentjs (value) {
      return value ? moment(value).format('DD/MM/YYYY') : '';
    },
    pickFile () {
      this.$refs.image.click ();
    },
    uploadPicture (e) {
      this.getBase64(e.target.files[0]).then(fileData => {
        this.foto = fileData;
      })
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    deleteFoto() {
      this.foto = undefined;
    },
    visible(item) {
      switch (item) {
        case 'aggressionDate':
          this.aggressionDateVisible = !this.aggressionDateVisible;
          break;
        case 'state':
          this.stateVisible = !this.stateVisible;
          break;
        case 'municipality':
          this.municipalityVisible = !this.municipalityVisible;
          break;
        case 'legalName':
          this.legalNameVisible = !this.legalNameVisible;
          break;
        case 'chosenName':
          this.chosenNameVisible = !this.chosenNameVisible;
          break;
        case 'whereWasFound':
          this.whereWasFoundVisible = !this.whereWasFoundVisible;
          break;
        case 'sexualIdentity':
          this.sexualIdentityVisible = !this.sexualIdentityVisible;
          break;
        case 'characteristic':
          this.characteristicVisible = !this.characteristicVisible;
          break;
        case 'age':
          this.ageVisible = !this.ageVisible;
          break;
        case 'nationality':
          this.nationalityVisible = !this.nationalityVisible;
          break;
        case 'occupation':
          this.occupationVisible = !this.occupationVisible;
          break;
        case 'details':
          this.detailsVisible = !this.detailsVisible;
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.input-group.input-group--dirty.input-group--required.input-group--text-field.primary--text {
  width: 150px;
}

.upload {
  display: flex;
  align-self: center;
  cursor: pointer;
  p {
    font-size: 0.8rem !important;
  }
  &:hover {
    opacity: 0.7;
  }
}
</style>
